import { useMemo } from "react";
import { usePostMessageHandler } from "./Handler";
import { ModalAction } from "./Actions";

type UseModalPostMessageHandlerProps = (close: () => void) => void;

const useModalPostMessageHandler: UseModalPostMessageHandlerProps = (close) =>
    usePostMessageHandler(
        useMemo(
            () => ({
                [ModalAction.Close]: close,
                [ModalAction.CloseLegacy]: close,
            }),
            [close]
        )
    );

export { useModalPostMessageHandler };
